let html = `<div class="watched-history selector">
    <div class="watched-history__icon">
        <svg><use xlink:href="#sprite-viewed"></use></svg>
    </div>
    <div class="watched-history__body">
        
    </div>
</div>`

export default html